import WorkoutLeaderboardPage from './WorkoutLeaderboardPage';

export default WorkoutLeaderboardPage;
